import * as React from 'react';
import { TeamStore } from 'nomst/Stores/team.store';
import { inject, observer } from 'mobx-react';
import './globalErrorView.scss';

export interface IGlobalErrorViewProps {
    store?: Nullable<TeamStore>;
    logoutOverride?: () => void;
}

export class GlobalErrorView extends React.Component<IGlobalErrorViewProps> {
    logout: Nullable<() => void>;
    constructor(props: IGlobalErrorViewProps) {
        super(props);
        const { store, logoutOverride } = this.props;
        this.logout = logoutOverride ? logoutOverride : (store ? store.logout : null);
        this.triggerLogout = this.triggerLogout.bind(this);
    }
    render(): React.ReactNode {
        return (
            <div className="global-error">
                <div className="main-error-content">
                    <img
                        alt=""
                        src={require('contents/lost_team.svg')}
                        className="lost-team-icon"
                    />
                    <div className="error-copy">
                        <h1 className="error-header">
                            Uh-oh, looks like you lost your team
                        </h1>
                        {this.renderSubHeader()}
                        <div className="error-footer">
                            If the issue persists, please contact customer support at cs@payscale.com
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    renderSubHeader(): React.ReactNode {
        return (
            <div className="error-sub-header">
                {`Try refreshing your page ${this.logout ? 'or ' : ''}`}
                {this.logout && <button className="pxl-link" onClick={this.triggerLogout}>return to login</button>}
            </div>
        );
    }

    private triggerLogout(): void {
        if (this.logout) {
            this.logout();
        }
    }
}

export default inject('store')(observer(GlobalErrorView));